export default function getResource(label) {
    const resources = { sortBy: 'Sort by' };

    return resources[label];
}
